import { CookiesComponent, SearchBarComponent } from '@app/components';

class PagesCommon {
    constructor() {
        new CookiesComponent();
        new SearchBarComponent();
        this.manageSidebarMenu();
    }

    /**
     * show / hide sidebar submenu items
     *
     * animates the icon on sidebar menu items
     */
    manageSidebarMenu() {
        this.hideSidebarOnItemSelected();

        const menuItemButtons = document.querySelectorAll('.sidebar__item-button');
        menuItemButtons.forEach((item) => {
            item.addEventListener('click', (event) => {
                const target = event.target as HTMLElement;
                let buttonElement = target.closest('.sidebar__item-button');
                if (!buttonElement) {
                    return;
                }

                buttonElement.classList.toggle('open');

                const parent = buttonElement.parentElement.parentElement;
                const submenus = parent.querySelectorAll('.sidebar__submenu');
                submenus[0]?.classList.toggle('open');
            });
        });
    }

    hideSidebarOnItemSelected() {
        const hamburgerMenuInputs = document.querySelectorAll('.hamburger-menu input');
        if (hamburgerMenuInputs.length !== 1) {
            throw Error('hamburger menu input not found');
        }
        const hamburgerMenuInput = hamburgerMenuInputs[0] as HTMLInputElement;
        const menuItems = document.querySelectorAll('.sidebar__item a');

        menuItems.forEach((item) => {
            item.addEventListener('click', () => {
                hamburgerMenuInput.checked = false;
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new PagesCommon();
});
